export default __webpack_public_path__ + "static/media/gear.44b83066.svg";